"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authenticateAxios = exports.responseErrorInterceptorFactory = exports.requestInterceptorFactory = void 0;
var axios_1 = __importDefault(require("axios"));
var authApi_1 = require("./authApi");
var runWithLockWithPromise_1 = __importDefault(require("./utilitiy/runWithLockWithPromise"));
function requestInterceptorFactory(storage) {
    var _this = this;
    return function (requestConfig) { return __awaiter(_this, void 0, void 0, function () {
        var jwt, config, token;
        return __generator(this, function (_a) {
            jwt = storage.getJWTToken();
            config = __assign(__assign({}, requestConfig), { withCredentials: false });
            if (jwt) {
                token = jwt.token;
                config = __assign(__assign({}, config), { currentToken: token, headers: __assign(__assign({}, config.headers), { Authorization: "Bearer ".concat(token) }) });
            }
            return [2 /*return*/, config];
        });
    }); };
}
exports.requestInterceptorFactory = requestInterceptorFactory;
function responseErrorInterceptorFactory(storage, runWithLockInstance, authApi, axiosInstance) {
    var _this = this;
    return function (error) { return __awaiter(_this, void 0, void 0, function () {
        var originalRequest;
        var _this = this;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    originalRequest = error.config;
                    if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) !== 401 || originalRequest.retry) {
                        return [2 /*return*/, Promise.reject(error)];
                    }
                    return [4 /*yield*/, runWithLockInstance('lock.sessionStorage', function () { return __awaiter(_this, void 0, void 0, function () {
                            var jwt;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        jwt = storage.getJWTToken();
                                        if ((jwt === null || jwt === void 0 ? void 0 : jwt.token) !== originalRequest.currentToken) {
                                            return [2 /*return*/];
                                        }
                                        originalRequest.retry = true;
                                        return [4 /*yield*/, authApi.refreshToken()];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                case 1:
                    _b.sent();
                    return [2 /*return*/, axiosInstance.request(originalRequest)];
            }
        });
    }); };
}
exports.responseErrorInterceptorFactory = responseErrorInterceptorFactory;
function authenticateAxios(instance, sessionStorage) {
    var authApi = new authApi_1.AuthApi(sessionStorage, axios_1.default);
    instance.interceptors.request.use(requestInterceptorFactory(sessionStorage));
    instance.interceptors.response.use(function (response) { return response; }, responseErrorInterceptorFactory(sessionStorage, runWithLockWithPromise_1.default, authApi, instance));
}
exports.authenticateAxios = authenticateAxios;
//# sourceMappingURL=authService.js.map